import {Component, Input, Output, EventEmitter} from "@angular/core";
import {trigger, state, style, transition, animate, keyframes} from "@angular/animations";
import {Message} from "./message.model";
import {TranslatableComponent} from "src/app/core/models/TranslatableComponent";
import {TranslateService} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";

@Component({
	selector: "app-chat-message",
	templateUrl: "./message.component.html",
	styleUrls: ["./message.component.scss"],
	animations: [
		trigger("copyPulse", [
			state("idle", style({transform: "scale(1)", opacity: 1})),
			state("copied", style({transform: "scale(1)", opacity: 1})),
			transition("idle => copied", [
				animate(
					"250ms ease-out",
					keyframes([
						style({transform: "scale(1)", opacity: 1, offset: 0}),
						style({transform: "scale(1.25)", opacity: 0.9, offset: 0.5}),
						style({transform: "scale(1.1)", opacity: 1, offset: 1}),
					]),
				),
			]),
			transition("copied => idle", [animate("200ms ease-in", style({transform: "scale(1)", opacity: 1}))]),
		]),
		trigger("iconFade", [
			transition(":enter", [
				style({opacity: 0, transform: "scale(0.8)"}),
				animate("150ms ease-out", style({opacity: 1, transform: "scale(1)"})),
			]),
			transition(":leave", [animate("150ms ease-in", style({opacity: 0, transform: "scale(0.8)"}))]),
		]),
		trigger("errorShake", [
			transition(":enter", [
				animate(
					"500ms ease-out",
					keyframes([
						style({transform: "translateX(0)", offset: 0}),
						style({transform: "translateX(-10px)", offset: 0.2}),
						style({transform: "translateX(10px)", offset: 0.4}),
						style({transform: "translateX(-8px)", offset: 0.6}),
						style({transform: "translateX(8px)", offset: 0.8}),
						style({transform: "translateX(0)", offset: 1}),
					]),
				),
			]),
		]),
	],
	imports: [MatIcon, MatTooltip],
})
export class ChatMessageComponent extends TranslatableComponent {
	@Input() message!: Message;
	@Output() copyRequest = new EventEmitter<{text: string; event: MouseEvent}>();

	copied: boolean = false;

	constructor(private _translate: TranslateService) {
		super(_translate, "ChatMessageComponent");
	}

	copyMessage(event: MouseEvent): void {
		this.copied = true;
		this.copyRequest.emit({text: this.message.text, event: event});

		setTimeout(() => {
			this.copied = false;
		}, 900);
	}

	get animationState(): string {
		return this.copied ? "copied" : "idle";
	}
}
